import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Workshops from '../views/Workshops.vue'
import WorkshopsDetails from '../views/WorkshopsDetails.vue'
import Blog from '../views/Blog.vue'
import Events from '../views/Events.vue'
import EventsCalendar from '../views/EventsCalendar.vue'


  const routes = [
    // ...Home,
    // ...About,
    // ...Workshops,
    // ...WorkshopsDetails,
    // ...Blog,
    // ...Events,
    // ...EventsCalendar
        {
          path: '/',
          name: 'home',
          meta: {
            layout: 'default'
          },
          component: Home
        },
        {
          path: '/nosotros',
          name: 'About',
          meta: {
              layout: 'default'
          },
          component: About
        },
        {
            path: '/blog',
            name: 'Blog',
            meta: {
                layout: 'default'
            },
            component: Blog
        },
        {
            path: '/talleres',
            name: 'Workshops',
            meta: {
                layout: 'default'
            },
            component: Workshops
        },
        {
          path: '/detalles',
          name: 'Workshopsdetails',
          meta: {
            layout: 'default'
          },
          component: WorkshopsDetails
        },
        {
          path: '/eventos',
          name: 'events',
          meta: {
            layout: 'default'
          },
          component: Events
        },
        {
          path: '/calendario',
          name: 'eventscalendar',
          meta: {
            layout: 'default'
          },
          component: EventsCalendar
        },

  ]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
